import { createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  id: "single-ticket-type-selection",
  class: "o-singleTicketTypeSelection"
}
const _hoisted_2 = { class: "o-singleTicketTypeSelection__heading" }
const _hoisted_3 = { class: "o-singleTicketTypeSelection__options" }
const _hoisted_4 = ["onClick", "data-qa"]
const _hoisted_5 = { class: "m-priceLevel__section -information -alternative" }
const _hoisted_6 = { class: "m-priceLevel__title -alternative" }
const _hoisted_7 = { class: "m-priceLevel__description -alternative" }
const _hoisted_8 = { class: "m-priceLevel__section -alternative" }
const _hoisted_9 = { class: "m-priceLevel__price" }
const _hoisted_10 = { class: "m-priceLevel__pricePrimary" }
const _hoisted_11 = {
  key: 0,
  class: "m-priceLevel__priceSecondary"
}
const _hoisted_12 = {
  key: 0,
  class: "m-priceLevel__unavailable"
}
const _hoisted_13 = ["data-qa"]
const _hoisted_14 = {
  key: 0,
  class: "m-priceLevel__section -notice"
}
const _hoisted_15 = {
  key: 0,
  class: "a-notice -error"
}
const _hoisted_16 = {
  key: 1,
  class: "a-notice -error"
}
const _hoisted_17 = { class: "o-singleTicketTypeSelection__actionWrapper" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_stepper_component = _resolveComponent("stepper-component")!
  const _component_button_component = _resolveComponent("button-component")!
  const _component_TicketFeeInfo = _resolveComponent("TicketFeeInfo")!
  const _directive_translate = _resolveDirective("translate")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _withDirectives((_openBlock(), _createElementBlock("p", null, [
        _createTextVNode(" Set desired amount of tickets, then choose the category")
      ])), [
        [_directive_translate, { key: _ctx.Translation.Ticket_selection_single_type_selection_heading }]
      ]),
      _createVNode(_component_stepper_component, {
        state: _ctx.stepperState,
        onStateChange: _ctx.handleStepperStateChange
      }, null, 8, ["state", "onStateChange"])
    ]),
    _createElementVNode("div", _hoisted_3, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.data, (priceLevel) => {
        return (_openBlock(), _createElementBlock(_Fragment, {
          key: priceLevel.priceLevelId
        }, [
          _createElementVNode("div", {
            class: _normalizeClass([{ '-available' : _ctx.isPriceLevelAvailable(priceLevel, _ctx.priceLevelState(priceLevel.priceLevelId))}, "m-priceLevel -alternative"]),
            onClick: ($event: any) => (_ctx.handlePriceLevelSelection(_ctx.priceLevelState(priceLevel.priceLevelId), priceLevel)),
            "data-qa": _ctx.PerformanceQASelectors.PRICE_LEVEL_ALTERNATIVE
          }, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("h4", _hoisted_6, _toDisplayString(_ctx.priceLevelState(priceLevel.priceLevelId).text), 1),
              _createElementVNode("p", _hoisted_7, _toDisplayString(_ctx.priceLevelState(priceLevel.priceLevelId).description), 1)
            ]),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("p", _hoisted_10, _toDisplayString(_ctx.CurrencyHandler.displayPrimaryCurrency(_ctx.priceFor(priceLevel))), 1),
                (_ctx.CurrencyHandler.isSecondaryCurrencyDisplayed)
                  ? (_openBlock(), _createElementBlock("small", _hoisted_11, _toDisplayString(_ctx.CurrencyHandler.displaySecondaryCurrency(_ctx.priceFor(priceLevel))), 1))
                  : _createCommentVNode("", true)
              ]),
              (!_ctx.isPriceLevelAvailable(priceLevel, _ctx.priceLevelState(priceLevel.priceLevelId)))
                ? (_openBlock(), _createElementBlock("p", _hoisted_12, _toDisplayString(priceLevel.statusDescription), 1))
                : _createCommentVNode("", true),
              (_ctx.isPriceLevelAvailable(priceLevel, _ctx.priceLevelState(priceLevel.priceLevelId)))
                ? (_openBlock(), _createElementBlock("div", {
                    key: 1,
                    class: _normalizeClass([{ '-is-active': _ctx.priceLevelState(priceLevel.priceLevelId)!.active }, "a-ticketModeOption__indicator"])
                  }, [
                    _createElementVNode("div", {
                      class: "a-ticketModeOption__indicatorCircle",
                      "data-qa": _ctx.PerformanceQASelectors.PRICE_LEVEL_CIRCLE_INDICATOR
                    }, null, 8, _hoisted_13)
                  ], 2))
                : _createCommentVNode("", true)
            ])
          ], 10, _hoisted_4),
          (_ctx.canDisplayNoticeSectionFor(priceLevel.priceLevelId))
            ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                (!_ctx.isMinRequirementReachedFor(_ctx.priceLevelState(priceLevel.priceLevelId)))
                  ? _withDirectives((_openBlock(), _createElementBlock("p", _hoisted_15, [
                      _createTextVNode("Minimum amount restriction not reached")
                    ])), [
                      [_directive_translate, {
                               key: _ctx.Translation.Ticket_selection_min_ticket_type,
                               keyValues: JSON.stringify({ 'placeholder-min-value': _ctx.getMinRestrictionFor(_ctx.priceLevelState(priceLevel.priceLevelId)) }),
                               identifierStart: '{',
                               identifierEnd: '}'
                       }]
                    ])
                  : _createCommentVNode("", true),
                (_ctx.shouldDisplayMaxErrorNoticeFor(priceLevel.priceLevelId))
                  ? _withDirectives((_openBlock(), _createElementBlock("p", _hoisted_16, [
                      _createTextVNode("Max amount restriction exceeded")
                    ])), [
                      [_directive_translate, {
                               key: _ctx.Translation.Seatmap_max_selection_error,
                               keyValues: JSON.stringify({ 'placeholder-max-selection': _ctx.getMaxRestrictionFor(_ctx.priceLevelState(priceLevel.priceLevelId)) }),
                               identifierStart: '{',
                               identifierEnd: '}',
                       }]
                    ])
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true)
        ], 64))
      }), 128))
    ]),
    _createElementVNode("div", {
      class: _normalizeClass([_ctx.CurrencyHandler.isSecondaryCurrencyDisplayed ? '-has-secondary-currency' : '', "o-singleTicketTypeSelection__action"])
    }, [
      _createElementVNode("div", _hoisted_17, [
        _createVNode(_component_button_component, {
          active: _ctx.activePriceLevel && _ctx.activePriceLevel.canSubmit,
          "icon-name": _ctx.IconName.Cart,
          label: _ctx.submitButtonLabel,
          "secondary-label": _ctx.CurrencyHandler.displaySecondaryCurrency(_ctx.ticketsPrice),
          "qa-selector": _ctx.PerformanceQASelectors.PRICE_LEVEL_SUBMIT,
          onSubmit: _cache[0] || (_cache[0] = ($event: any) => (_ctx.handleSubmitSelection(_ctx.activePriceLevel)))
        }, null, 8, ["active", "icon-name", "label", "secondary-label", "qa-selector"]),
        _createVNode(_component_TicketFeeInfo, {
          "fee-list": _ctx.bestSeatStore.fees,
          "ticket-price-list": _ctx.getSelectedTicketsPriceList(),
          "currency-handler": _ctx.CurrencyHandler,
          "has-opacity": _ctx.stepperState.amount === 0
        }, null, 8, ["fee-list", "ticket-price-list", "currency-handler", "has-opacity"])
      ])
    ], 2)
  ]))
}